



















































import { getPatientName } from '@/utils/patients'
import ExerciseButton from '@/components/exercises/components/ExerciseButton.vue'

export default {
  components: {
    ExerciseButton,
  },
  props: {
    currentPatientId: {
      type: String,
      default: '',
    },
    exercisesByUserAndDate: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      selected: false,
      selectedPatientId: '',
      selectedPatientIds: {},
    }
  },
  mounted() {
    this.selectedPatientIds = {
      [this.currentPatientId]: true,
    }
  },
  methods: {
    togglePatientHistory(id: string): void {
      if (this.selectedPatientIds[id]) {
        this.selectedPatientIds = {
          ...this.selectedPatientIds,
          [id]: false,
        }
      } else {
        this.selectedPatientIds = {
          ...this.selectedPatientIds,
          [id]: true,
        }
      }
    },
    getSampleKeyFromObject(obj: object): string | null {
      // tslint:disable-next-line
      for (const _key in obj) {
        return _key
      }
      return null
    },
    getPatientNameFromExercisesByDate(exercisesByDate): string {
      const sampleExercise = exercisesByDate[this.getSampleKeyFromObject(exercisesByDate)][0]
      return getPatientName({
        id: sampleExercise.patientId,
        lastName: sampleExercise.patientLastName,
        firstName: sampleExercise.patientFirstName,
      })
    },
  },
}
